import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ISibasiHTTPResponse } from '../../model/sibasiHTTPResponse.model';
import { IFaq } from '../../model/support.model';
@Injectable({
  providedIn: 'root'
})
export class FaqService {
  constructor(private http: HttpClient) {}

  public getAllFaqs(): Observable<ISibasiHTTPResponse<[]>> {
    return this.http.get<ISibasiHTTPResponse<[]>>(
      `${environment.api_url}sibasiFAQ/public/all`
    );
  }
  public getFaqById(faqId: string): Observable<ISibasiHTTPResponse<IFaq>> {
    return this.http.get<ISibasiHTTPResponse<IFaq>>(
      `${environment.api_url}sibasiFAQ/public/${faqId}`
    );
  }
  public addFaq(faq: IFaq): Observable<ISibasiHTTPResponse<IFaq>> {
    return this.http.post<ISibasiHTTPResponse<IFaq>>(
      `${environment.api_url}sibasiFAQ`,
      faq
    );
  }
  public deleteFaq(faqId: any) {
    return this.http.delete(`${environment.api_url}sibasiFAQ/${faqId}`);
  }
  public updateFaq(faqId: any, faq: {}): Observable<ISibasiHTTPResponse<IFaq>> {
    return this.http.post<ISibasiHTTPResponse<IFaq>>(
      `${environment.api_url}sibasiFAQ/${faqId}`,
      faq
    );
  }
}
